<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ 'Yolcum Nerede' }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"
                append-icon="search"></v-text-field>
              
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid v-if="raportipi=='Bilet'">
            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex pb-3 xs12 sm12 md12>
                        <v-card flat>
                          <v-layout row wrap>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="$t('Date')" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.VarisTarih1" v-model="Rapor.VarisTarih1"></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="$t('Date')" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.VarisTarih2" v-model="Rapor.VarisTarih2"></tarihcomp>
                            </v-flex>
                              <v-flex xs12 sm6 pt-2 md2>
                             <parkurcomp v-model="Rapor.VarisParkur"></parkurcomp>
                            </v-flex>
    
  <v-flex xs12 sm6 md2 pt-2>
                                                        <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.Musteri_Kodu" v-model="Rapor.Musteri_Kodu"></cariaracomp>
                                                    </v-flex>


                            <v-flex pt-2>
                              <v-layout align-center="">
                                <div v-if="load1">
                                  <v-btn color="info" @click="getListOtel()" fab small="" dark>
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </div>
                                <div v-if="progress">
                                  <v-layout align-center="">
                                    <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                                  </v-layout>
                                </div>
                               
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                  </v-form>

                </v-card>
              </v-flex>

              <v-flex xs12  sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table :headers="headersbaslik" :rows-per-page-items=[20,50,100,200]
                              :items="itemssatis" :search="searchsatilanbilet">
                              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        
                               <template slot="items" slot-scope="props">
                                  <tr  item>
                                    <td class="text-xs-left">{{ props.item.Parkur }}</td>
                                     <td class="text-xs-left">{{ props.item.VarisParkur }}</td>
                                      <td class="text-xs-left">{{ props.item.UcusTar | dateformat }}</td>
                                         
                                     <td class="text-xs-left">{{ props.item.UcusSaat}}</td>
                                    <td class="text-xs-left">{{ props.item.VarisTar | dateformat  }}</td>
  <td class="text-xs-left">{{ props.item.VarisSaat }}</td>
                                       <td class="text-xs-left">{{ props.item.YolcuAdi}}</td>
                                        <td class="text-xs-left">{{ props.item.bilettel }}</td>
                                         <td class="text-xs-left">{{ props.item.email }}</td>
                                         <td class="text-xs-left">{{ props.item.Musteri_Kodu }}</td>
                                          <td class="text-xs-left">{{ props.item.Bilet_No }}</td>
                                      
                                       
                                    
                                  </tr>
                                </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
<v-container fluid v-if="raportipi=='Otel'">
            <v-layout row wrap>
              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formgunluksatisotel" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex pb-3 xs12 sm12 md12>
                        <v-card flat>
                          <v-layout row wrap>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="$t('Date')" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="RaporOtel.Tarih1" v-model="RaporOtel.Tarih1"></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="$t('Date')" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="RaporOtel.Tarih2" v-model="RaporOtel.Tarih2"></tarihcomp>
                            </v-flex>
                            
    
  <v-flex xs12 sm6 md2 pt-2>
                                                        <cariaracomp  :Coper="true" v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="RaporOtel.Cari_Kod" v-model="RaporOtel.Cari_Kod"></cariaracomp>
                                                    </v-flex>
<v-flex xs12 sm6 md2 pt-2>
                                                        <pnrbul v-model="RaporOtel.PNR_No" hide-details> </pnrbul>
                                                    </v-flex>

                            <v-flex pt-2>
                              <v-layout align-center="">
                                <div v-if="load1">
                                  <v-btn color="info" @click="getListOtel()" fab small="" dark>
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </div>
                                <div v-if="progress">
                                  <v-layout align-center="">
                                    <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                                  </v-layout>
                                </div>
                                 <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green"
                                >check_circle_outline</v-icon
                              >
                            </template>

                            <v-btn
                              small
                              @mouseenter="tooltip = true"
                              @mouseleave="tooltip = false"
                              ref="fab"
                              @click="filtrele()"
                              color="info"
                              fab
                              dark
                            >
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                  </v-form>

                </v-card>
              </v-flex>

              <v-flex xs12  sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table :headers="headersbaslikotel" :rows-per-page-items=[20,50,100,200]
                              :items="itemssatisotel" :search="searchsatilanbilet">
                              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
       
                               <template slot="items" slot-scope="props">
                                  <tr  item>
                                    <td class="text-xs-left">{{ props.item.Cari_Kod }}</td>
                                      <td class="text-xs-left">
  <a href="#"
     @click.prevent.stop="pnrGit(props.item.PNR_No)"
     style="color:#1976d2; text-decoration:underline; cursor:pointer;">
     {{ props.item.PNR_No }}
  </a>
</td>

                                      <td class="text-xs-left">{{ props.item.Ad }}</td>
                                         
                                     <td class="text-xs-left">{{ props.item.GSM}}</td>
                                    <td class="text-xs-left">{{ props.item.Telefon1  }}</td>
  <td class="text-xs-left">{{ props.item.Email }}</td>
                                       <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                        <td class="text-xs-left">{{ props.item.SaticiUlke }}</td>
                                         <td class="text-xs-left">{{ props.item.SaticiSehir }}</td>
                                         <td class="text-xs-left">{{ props.item.SaticiYer }}</td>
                                          <td class="text-xs-left">{{ props.item.Donem1 | dateformat }}</td>
                                       <td class="text-xs-left">{{ props.item.Donem2 | dateformat }}</td>
                                       
                                    
                                  </tr>
                                </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="350px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                    <genelarama
                      :autofocuss="true"
                      apiname="SaticiAra"
                      :tip="1"
                      :label="$t('Seller-Code')"
                      v-model="RaporOtel.SaticiAdi"
                    ></genelarama>
                  </v-flex>
                            <v-autocomplete
                              :items="ulkeTipi"
                              hide-details=""
                              :no-data-text="$t('No-Records-Found')"
                              v-model="RaporOtel.SaticiUlke"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('Country_label')"
                              @change="getCity(RaporOtel.SaticiUlke)"
                            >
                          
                            </v-autocomplete>

                            <v-autocomplete
                              @change="getDistinct(RaporOtel.SaticiSehir)"
                              :items="sehirTipi"
                              hide-details=""
                              v-model="RaporOtel.SaticiSehir"
                              :no-data-text="$t('No-Records-Found')"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('City')"
                            >
                           
                            </v-autocomplete>

                            <v-autocomplete
                             
                              :no-data-text="$t('No-Records-Found')"
                              :items="ilceTipi"
                              hide-details=""
                              v-model="RaporOtel.SaticiYer"
                              item-text="Isim"
                              item-value="Isim"
                              :label="$t('District')"
                            >
                           
                            </v-autocomplete>

                           

                             <v-flex xs12 sm12 md12>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="RaporOtel.tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import havayollaritumlistecomp from "@/components/app/customcomp/havayollaritumlistecomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import tool from "../../coper/tools";
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"
import pnrbul from "@/components/app/coper/component/pnrbul.vue"
import genelarama from "@/components/app/coper/comp/genelarama.vue";
  export default {
    data() {
      return {
         ulkeTipi: [],
      sehirTipi: [],
      ilceTipi: [],
      semtTipi: [],
        rules: {
          required: v => !!v || 'Zorunlu alan',
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
        },
        PB:'TRY',
        raportipi:"Otel",
        raportipleri:[
          "Bilet","Otel"
        ],
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        kayitvarmi: false,
        
        search: '',
        searchsatilanbilet: null,
      
    

 headersbaslikotel: [
 {
            text: "Müşteri",
            value: "Cari_Kod",
            width: "5%",
            align: "left"
          },
 {
            text: "PNR_No",
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: "Ad",
            value: "Ad",
            width: "5%",
            align: "left"
          },
             {
            text: "GSM",
            value: "GSM",
            width: "5%",
            align: "left"
          },
             {
            text: "Telefon1",
            value: "Telefon1",
            width: "5%",
            align: "left"
          },
          
           {
            text: "Email",
            value: "Email",
            width: "5%",
            align: "left"
          },
            {
            text: "Satıcı",
            value: "SaticiAdi",
            width: "5%",
            align: "left"
          },
             {
            text: "Satıcı Ülke",
            value: "SaticiUlke",
            width: "5%",
            align: "left"
          },
            {
            text: "Satıcı Şehir",
            value: "SaticiSehir",
            width: "5%",
            align: "left"
          },
             {
            text: "Satıcı Yer",
            value: "SaticiYer",
            width: "5%",
            align: "left"
          },
           {
            text: "Başlangıç Tarih",
            value: "Donem1",
            width: "5%",
            align: "left"
          },
             {
            text: "Bitiş Tarih",
            value: "Donem2",
            width: "5%",
            align: "left"
          },
        ],

        headersbaslik: [
 {
            text: "Kalkış",
            value: "Parkur",
            width: "5%",
            align: "left"
          },
 {
            text: "Varış",
            value: "VarisParkur",
            width: "5%",
            align: "left"
          },
          {
            text: "Uçuş Tarihi",
            value: "UcusTar",
            width: "5%",
            align: "left"
          },
             {
            text: "Uçuş Saat",
            value: "UcusSaat",
            width: "5%",
            align: "left"
          },
             {
            text: "Varış Tarihi",
            value: "VarisTar",
            width: "5%",
            align: "left"
          },
          
           {
            text: "Varış Saat",
            value: "VarisSaat",
            width: "5%",
            align: "left"
          },
            {
            text: "Yolcu Adı",
            value: "YolcuAdi",
            width: "5%",
            align: "left"
          },
             {
            text: "Tel.",
            value: "bilettel",
            width: "5%",
            align: "left"
          },
            {
            text: "E-Mail",
            value: "email",
            width: "5%",
            align: "left"
          },
             {
            text: "Müşteri",
            value: "Musteri_Kodu",
            width: "5%",
            align: "left"
          },
           {
            text: "Bilet_No",
            value: "Bilet_No",
            width: "5%",
            align: "left"
          },
        ],

        Rapor: {
  "VarisParkur": null,
  "VarisTarih1": "",
  "VarisTarih2": "",
  "Musteri_Kodu": null,
        
        },
         RaporOtel: {
   "Cari_Kod": null,
  "PNR_No": null,
  "SaticiAdi": null,
  "SaticiUlke": null,
  "SaticiSehir": null,
  "SaticiYer": null,
 "Tarih1": "",
  "Tarih2": "",
  "tumSirketler": false,
  "sayfaAdi": null

        
        },
        valid: true,
        tumsirketler: '',
        loadingana: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',
        statecariana: [],
        searchcariana: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemssatisotel:[],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
 tool.http_post(this, "UlkeList", {}).then(
    (response) => {
      if (response.body.Status == true) {
        this.ulkeTipi = response.body.data;
      } else {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Service Unavailable";
      this.snackbar = true;
    }
  );
      if (this.sayfayetki.Status == true) {

       



      

      } else {

       

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      yuzdeinput,
      havayollaritumlistecomp,
      masrafmerkezicomp,
      yetkidialog,
      parkurcomp,
      cariaracomp,
      pnrbul,
      genelarama,
    },
    watch: {
    },
    methods: {
  getCity(value) {
    
      if (value != null && value !== "undefined") {
        var ulkeId = 0;

        if (value !== value) {
          ulkeId = null;
          this.ulkeTipi.forEach((element) => {
            if (element.Isim === this.RaporOtel.SaticiUlke) {
              ulkeId = element.Id;
            }
          });
        } else {
          this.ulkeTipi.forEach((element) => {
            if (element.Isim === value) {
              ulkeId = element.Id;
            }
          });
        }

        var params = {
          UlkeId: ulkeId,
        };

        tool.http_post(this, "IlList", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.sehirTipi = response.body.data;
              if (this.RaporOtel.SaticiSehir != null) {
                this.getDistinct(this.RaporOtel.SaticiSehir);
              }
            } else {
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
     getDistinct(value) {
      if (value != null) {
        var SehirId = 0;
        if (value !== value) {
          SehirId = null;
          this.sehirTipi.forEach((element) => {
            if (element.Isim === this.RaporOtel.SaticiSehir) {
              SehirId = element.Id;
            }
          });
        } else {
          this.sehirTipi.forEach((element) => {
            if (element.Isim === value) {
              SehirId = element.Id;
            }
          });
        }
        var params = {
          IlId: SehirId,
        };

        tool.http_post(this, "IlceList", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.ilceTipi = response.body.data;
              if (this.RaporOtel.SaticiYer != null) {
                
              }
            } else {
            }
          },
          (response) => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
  pnrGit(val){
  let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val;
        window.open(url, "_target");
      },
 

  


      getList: getList,
      getListOtel:getListOtel,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      tarihformat
    }
  }

  function tarihformat(t) {

    if (t != null) {
      var a = t.split("/")
      var tarih1 = a[0].replace('00:00:00', '') + " " + a[1].replace('00:00:00', '')
      return tarih1;
    } else {
      return null
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgrubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      }
    })


  }


  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getListOtel()
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
   
  }


function getListOtel(){
  if (this.RaporOtel.SaticiAdi){
    this.RaporOtel.SaticiAdi=this.RaporOtel.SaticiAdi.isim;
  }
tool.http_post(this, 'OtelIsimListesi',this.RaporOtel).then(
response => {
if (response.body.Status == true)
{
  this.itemssatisotel=response.body.data;
console.log('OtelIsimListesi response :');
console.log(response.body.data);
}
else
{
this.text1 = response.body.ErrorList[0]
  this.snackbar = true
}
},
response => {
this.text1 = 'Hata Oluştu, tekrar deneyiniz'
this.snackbar = true
}
);

}

  function getList() {
tool.api_post(this, 'TicketReport/UcusVarisListReport',this.Rapor).then(
response => {
if (response.body.Status == true)
{
console.log('TicketReport/UcusVarisListReport response :');
console.log(response.body);
this.itemssatis=response.body.data;
}
else
{
this.text1 = response.body.ErrorList[0]
  this.snackbar = true
}
},
response => {
this.text1 = 'Hata Oluştu, tekrar deneyiniz'
this.snackbar = true
}
);

  
  }



  function getListHtml() {
   
  }



  function getListExcel() {

var params = this.RaporOtel

      tool.api_post_FileDownload(this, "Coper/ExcelOtelIsimListesi", params).then(
          response => {
            tool.CreateDownloadLink(response, 'YolcumNerede.xlsx');
            this.progress = false;
            this.load1 = true;


          },
          response => {
            this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
     
    }


  function beforeMount() {
  }

</script>

<style>
</style>